import type { UserRole, UserSummary } from 'chery-contracts';

export const CHANGE_PASSWORD_PATH = '/change-password';

/** Plan §7 (decision 19): the Board is home for every role — the first thing anyone sees after signing in. */
export const landingPathFor = (_role: UserRole): string => '/board';

/**
 * Where a signed-in user goes next: the forced password change before anything else, otherwise the page they
 * were sent away from, otherwise their landing page.
 */
export const nextPathAfterSignIn = (user: Pick<UserSummary, 'role' | 'mustChangePassword'>, from?: string | null): string => {
  if (user.mustChangePassword) {
    return CHANGE_PASSWORD_PATH;
  }

  if (from && from.startsWith('/') && !from.startsWith('//') && from !== '/login' && from !== CHANGE_PASSWORD_PATH) {
    return from;
  }

  return landingPathFor(user.role);
};
